import styled, { createGlobalStyle } from 'styled-components';
import Input from './ui/input';
import { WARNING_100, NEUTRAL_GRAY_400, NEUTRAL_GRAY_500, NEUTRAL_GRAY_900, WHITE, WHITE_SMOKE } from './ui/colors';

export const GlobalStyle = createGlobalStyle`
  html,body {
    height: 100%;
    width: 100%;
    max-height: ${window.screen.height}px;
    margin: 0;
    padding: 0;
    display: flex;
    background: ${WHITE_SMOKE};
    overflow: auto;
  }

  #root-unico-idpay-ecommerce {
    background: ${WHITE_SMOKE};
    height: 100%;
    display: flex;
    width: 100%;
    justify-content: center;
    min-height: fit-content;
  }

  .swal2-styled {
    background: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    outline: none !important;
  }

  .swal2-html-container {
    color: #767676;
    font-size: 14px;
    margin: 0 0 14px 0;
    padding: 8px 24px;
  }

  .swal2-html-container p {
    margin: 0;
  }

  .swal2-title p {
    color: #131516!important;
    font-size: 18px;
    font-weight: 500;
    margin: 0;
  }

  .swal2-title img {
    margin-bottom: 16px;
  }

  .swal2-actions {
    margin-top: 0;
  }
`;

export const PageTitle = styled.h1`
  color: ${NEUTRAL_GRAY_900};
  font-size: ${props => props.fontSize || '20px'};
  line-height: 30px;
  width: 100%;
  display: inline-block;
  max-width: 500px;
  padding-top: 8px;
`;

export const PageSubtitle = styled.p`
  font-size: ${props => props.fontSize || '16px'};
  line-height: 26px;
  width: 100%;
  max-width: 340px;
  justify-self: center;
  color: ${NEUTRAL_GRAY_500};
`;

export const LoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 500px;
  border-radius: 16px;
  margin: 0 auto;
  height: 100%;

  & span {
    font-size: 24px;
  }

  & p {
    font-size: 12px;
    margin-top: 8px;
  }
`;

export const ButtonsArea = styled.div.attrs({ id: 'buttons-area' })`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 16px 8px 16px;
  align-items: center;
  gap:8px;
  border-radius: 0px 0px 16px 16px;
  background: ${WHITE};

  ${({ desktopView }) => !desktopView && `
    @media screen and (max-width: 1201px) {
      position: sticky;
      bottom: 0;
    }
  `}

  ${({ desktopView }) => desktopView && `
    border-top: 0px;
    background: none;
  `}
`;

export const FormContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  max-width: 340px;
  text-align: left;

  & input {
    font-size: 16px;
    height: 44px;
  }

  & form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  & .ant-form-item {
    margin-bottom: 0;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 16px;
  align-items: center;
  margin: 0 auto;
`;

export const ExpirationTime = styled.p`
  font-size: 14px;
  color: ${NEUTRAL_GRAY_400};
  text-align: center;
`;

export const setButtonsAreaShadow = () => {
  const bodyElement = document.getElementsByTagName('body')[0];
  const buttonsAreaElement = document.getElementById('buttons-area');
  if (bodyElement.scrollHeight > bodyElement.clientHeight && buttonsAreaElement) {
    buttonsAreaElement.style.boxShadow = '0px -2px 24px 0px #1616161F';
  }
}

export const setDynamicStyle = (isMobile) => {
  Object.assign(document.getElementById('root-unico-idpay-ecommerce').style, {
    background: 'transparent',
    height: 'fit-content',
  });

  Object.assign(document.documentElement.style, {
    background: 'transparent',
  });

  Object.assign(document.body.style, {
    background: 'transparent',
    alignSelf: 'end',
    borderRadius: '16px',
    width: 'calc(100vw - 32px)',
    maxHeight: 'calc(-32px + 100vh)',
    height: isMobile ? 'fit-content' : "100%",
    justifySelf: 'anchor-center',
    position: !isMobile ? 'fixed' : 'relative',
    top: !isMobile ? '16px' : '',
    bottom: isMobile ? '16px' : '',
    left: isMobile ? '16px' : '',
  });
}

export const Warning = styled.div`
  align-items: center;
  background: ${WARNING_100};
  box-shadow: 0 2px 2px rgba(0,0,0,.05);
  display: flex;
  font-size: 15px;
  gap: 8px;
  min-height: 44px;
  justify-content: center;
  user-select: none;
  width: 100%;
  max-width: 340px;
  margin-top: 7px;
  padding: 8px;
`;

export const WarningCompact = styled(Warning)`
  max-width: 340px;
  padding-top: 16px;
  font-size: 14px;
  padding: 6px;
`;

export const BtnCopyLink = styled.button`
  align-items: center;
  background: none;
  border: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  outline: none;
  user-select: none;
`;

export const LinkInput = ({ children, ...props }) =>
  <div style={{
    background: 'transparent',
    border: `1px solid ${NEUTRAL_GRAY_400}`,
    borderRadius: 8,
    display: 'flex',
    margin: 'auto',
    padding: '0 12px 0 24px',
    outline: 'none',
    flexDirection: 'row',
    gap: 8
  }}>
    <Input {...props} readOnly style={{
      background: 'none',
      border: 'none',
      color: NEUTRAL_GRAY_900,
      fontSize: '18px',
      fontWeight: 700,
      outline: 'none',
      boxShadow: 'none',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      padding: 0
    }} />
    {children}
  </div>;